// extracted by css-extract-rspack-plugin
module.exports =  {"clientTeamLabel":"RemoveClientTeam__clientTeamLabel___y3wDV","reasonLabel":"RemoveClientTeam__reasonLabel___P26Tp","reasonHelp":"RemoveClientTeam__reasonHelp___Ysyx7"};